import { render, staticRenderFns } from "./ViewAppsConfig.vue?vue&type=template&id=6d0d59f0&"
import script from "./ViewAppsConfig.vue?vue&type=script&lang=js&"
export * from "./ViewAppsConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports